export default {
  EDIT_NOTE: 'editNote',
  DELETE: 'delete',
  TRANSLATE: 'translate',
  LOOKUP: 'lookup',
  PLAY: 'play',
  NOTE: 'note',
  SEARCH: 'search',
  EXTRACT: 'extract',
  BOOKMARK: 'bookmark',
  COPY: 'copy',
  SHARE: 'share',
  SOCIAL_SHARING: 'socialSharing',
  REPORT: 'report',
  COMMENT: 'comment',
  ESSAY: 'essay',
  QUIZE: 'quiz',
  FLASHCARD: 'flashcard',
  DISSCUSSION: 'discussion',
  RESET: 'reset-',
  CUT: 'cut',
  CORRECT: 'correct',
  TYPO: 'typo',
  BLOG_QUOTE: 'blogQuote'
};
